export const getQueryString = (queries, ...keys) => {
	const queryKeys = Object.keys(queries);
	if (!queryKeys.length) {
		return '';
	}
	return Object.keys(queries)
		.reduce((string, key, i) => {
			return `${string}${i !== 0 ? '&' : ''}${key}=${queries[key]}`;
		}, '?');
};



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/utils/queryString.js